import Loading from "../../components/Loading";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import { onOrderLoadDetails, onOrdersChangeType, onStaffOrdersLoad } from '../../store/Orders/actions';
import ListDetails from "./components/ListDetails";
import ListOrders from "./components/ListOrders";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {TYPE_COMPLETED, TYPE_LIVEORDERS} from "../../store/Orders/reducer";
import {BtnColor} from "../../components/Button/Button";

const List = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [menuState, setMenuState] = useState(TYPE_LIVEORDERS)

    const setTab = (type) => {
        setMenuState(type)
        dispatch(onOrdersChangeType(type))
    }

    const { orders, order, order_loading, loading, type, onlyFood } = useSelector(({ orders }) => orders)

    useEffect(() => {
        dispatch(onStaffOrdersLoad())
    }, [type])

    const onOrderClick = (orderId) => dispatch(onOrderLoadDetails(orderId))
// text-gray-500 bg-gray-200
    return (
        <div className="mt-5">
            <div className="container  mx-auto">

                <div className={'w-full'}>
                    <ul className='flex cursor-pointer w-full'>
                        <li className={classNames('w-full py-2 px-6 bg-white rounded-t-lg text-center', {
                            'bg-gray-800 text-white ': menuState === TYPE_LIVEORDERS
                        })} onClick={() => setTab(TYPE_LIVEORDERS)}>{t('Live orders')}</li>
                        <li className={classNames('w-full py-2 px-6 bg-white rounded-t-lg text-center', {
                            'bg-gray-800 text-white': menuState === TYPE_COMPLETED
                        })} onClick={() => setTab(TYPE_COMPLETED)}>{t('Completed')}</li>
                    </ul>
                </div>

                <Loading loading={loading}>
                    <ListOrders
                        orders={orders.data}
                        onOrderClick={onOrderClick}
                        order={order}
                        orderLoading={order_loading}/>
                </Loading>

                {/*<div className="container flex mx-auto">*/}



                {/*    <div className="w-1/3">*/}
                {/*        <Loading loading={loading}>*/}
                {/*            <ListOrders*/}
                {/*                orders={orders.data}*/}
                {/*                onOrderClick={onOrderClick}*/}
                {/*                order={order}*/}
                {/*                orderLoading={order_loading}/>*/}
                {/*        </Loading>*/}
                {/*    </div>*/}

                {/*    <div className="w-2/3 ml-2">*/}
                {/*        <Loading loading={order_loading}>*/}
                {/*            <ListDetails order={order} onlyFood={onlyFood} />*/}
                {/*        </Loading>*/}
                {/*    </div>*/}

                {/*</div>*/}
            </div>
        </div>
    );
}

export default List
